import { Routes, Route, Outlet } from "react-router-dom";
import Portfolio from "../pages/Portfolio";
import PortfolioContextProvider from "../context/PortfolioContextProvider";

export default function PortfolioRoutes() {
  return (
    <>
      <PortfolioContextProvider>
        <Routes>
          <Route path="/" element={<Portfolio />} />
        </Routes>
        <Outlet />
      </PortfolioContextProvider>
    </>
  );
}
